import React from 'react';
import { shape, string } from 'prop-types';

import ConfirmationModal from './ConfirmationModal';

import classes from './RuleExceptionModal.module.css';

const RuleExceptionModal = ({ exception, ...props }) => (
    <ConfirmationModal
        cancelable={false}
        confirmText="OK"
        title="Rule Target Error Message"
        {...props}
    >
        <dl className={classes.exception}>
            <dt>Rule Name</dt>
            <dd>{exception.ruleName}</dd>

            <dt>Error Message</dt>
            <dd>{exception.notes}</dd>
        </dl>
    </ConfirmationModal>
);


RuleExceptionModal.defaultProps = {
    exception: {}
};

RuleExceptionModal.propTypes = {
    exception: shape({
        notes:    string,
        ruleName: string
    })
};

export default RuleExceptionModal;
